import { Badge } from "@heroui/react";

import { NotesSearchDesktop } from "@/features/notes/components/Notes/NotesSearch.desktop";
import { NotesSearchMobile } from "@/features/notes/components/Notes/NotesSearch.mobile";
import { NotesTagsFilterDrawer } from "@/features/notes/components/Notes/NotesTagsFilterDrawer";
import { FetchedTag } from "@/services/api/fetchers/tags";

interface NotesSearchAndFiltersProps {
  deviceType: "desktop" | "mobile";
  hasNotes: boolean;
  isSelectionMode: boolean;
  tags: FetchedTag[];
  selectedTags: FetchedTag[];
  onSearchChange: (value: string) => void;
  onTagsChange: (newTags: FetchedTag[]) => void;
}

export function NotesSearchAndFilters({
  deviceType,
  hasNotes,
  isSelectionMode,
  tags,
  selectedTags,
  onSearchChange,
  onTagsChange,
}: NotesSearchAndFiltersProps) {
  if (!hasNotes || isSelectionMode) {
    return null;
  }

  if (deviceType === "desktop") {
    return (
      <NotesSearchDesktop
        tags={tags}
        selectedTags={selectedTags}
        onSearchChange={onSearchChange}
        onTagsChange={onTagsChange}
      />
    );
  }

  return <NotesSearchMobile onSearchChange={onSearchChange} />;
}

interface NotesFilterBadgeProps {
  selectedTags: FetchedTag[];
  selectedTagIds: string[];
  onTagsFilterChange: (newSelectedTagIds: string[]) => void;
}

export function NotesFilterBadge({ selectedTags, selectedTagIds, onTagsFilterChange }: NotesFilterBadgeProps) {
  return (
    <Badge
      content={selectedTags.length > 0 ? selectedTags.length : undefined}
      color="primary"
      size="sm"
      showOutline={false}
    >
      <NotesTagsFilterDrawer selectedTags={selectedTagIds} onTagsChange={onTagsFilterChange} />
    </Badge>
  );
}
